import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=2c2c1834&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=2c2c1834&scoped=true&lang=scss&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=2c2c1834&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c1834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2c1834')) {
      api.createRecord('2c2c1834', component.options)
    } else {
      api.reload('2c2c1834', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=2c2c1834&scoped=true&", function () {
      api.rerender('2c2c1834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/Contacts.vue"
export default component.exports